// English (EN)
export const en = {
  // Navigation
  home: "Home",
  back: "Back",
  products: "Products",
  contact: "Contact",
  support: "Support",
  login: "Login",
  register: "Register",
  admin: "Admin",
  logout: "Logout",

  // Home Page
  fastDelivery: "Fast Delivery",
  viewProducts: "View Products",
  getInTouch: "Get In Touch",

  // Products
  allProducts: "All Products",
  addToCart: "Add to Cart",
  discount: "Discount!",
  price: "Price",
  originalPrice: "Original Price",
  quantity: "Quantity",
  rating: "Rating",

  // Product Detail
  productDetails: "Product Details",
  weight: "Weight",
  shelfLife: "Shelf Life",
  ingredients: "Ingredients",
  allergens: "Allergens",
  aboutProduct: "About Product",
  youMayAlsoLike: "You May Also Like",

  // Cart
  shoppingCart: "Shopping Cart",
  cartEmpty: "Your cart is empty",
  continueShopping: "Continue Shopping",
  proceedToCheckout: "Proceed to Checkout",
  removeItem: "Remove",
  cartEmptyDesc: "You haven't added any products to your cart yet. Visit our products page to discover our delicious treats!",
  itemsInCart: "{count} items in your cart",
  cartContents: "Cart Contents",
  clearCart: "Clear Cart",
  confirmClearCart: "Are you sure you want to completely clear your cart?",
  orderSummary: "Order Summary",
  calculatingShipping: "Calculating...",
  shippingCalculatedAtCheckout: "Calculated at checkout",

  // Checkout
  checkout: "Checkout",
  paymentMethod: "Payment Method",
  firstName: "First Name",
  lastName: "Last Name",
  city: "City",
  postalCode: "Postal Code",
  agreeTerms: "I agree to the terms and conditions",
  checkoutSubtitle: "Enter your information to complete your order",
  guestCardOnlyNotice: "Guest orders can only be paid by card.",
  termsAndConditions: "Terms and Conditions",
  agreeTermsAndPrivacy: "I have read and agree to the {terms} and {privacy}.",
  qtyUnit: "units",
  backToCart: "Back to Cart",
  sslEncryption: "256-bit SSL Encryption",
  enterCityForShipping: "Enter your city",
  orderCreationFailed: "The order could not be created.",
  orderCreationError: "An error occurred while creating your order.",
  checkoutEmptyCartDesc: "You need to add products to your cart before you can check out.",
  downloading: "Downloading...",
  invoiceDownloadFailed: "The invoice could not be downloaded. Please try again later.",

  // Order
  orderSuccess: "Order Successful!",
  orderSuccessMessage: "Your order has been processed successfully. We will send you order details via email shortly.",
  orderDetails: "Order Details",
  orderNumber: "Order No",
  date: "Date",
  status: "Status",
  confirmed: "Confirmed",
  emailConfirmation: "Email Confirmation",
  emailConfirmationDesc: "Check the email containing your order details",
  preparing: "Preparing",
  preparingDesc: "Your products are being carefully prepared",
  delivery: "Delivery",
  deliveryDesc: "Fresh products are coming to your door",
  trackOrder: "Track Order",

  // Order Tracking
  trackYourOrder: "Track Your Order",
  enterOrderId: "Enter order ID or tracking number",
  orderNotFound: "Order not found",
  shippingAddress: "Shipping Address",
  trackingNumber: "Tracking Number",
  orderItems: "Order Items",
  orderPlaced: "Order Placed",
  processing: "Processing",
  shipped: "Shipped",
  outForDelivery: "Out for Delivery",
  delivered: "Delivered",
  estimatedDelivery: "Estimated Delivery",
  downloadInvoice: "Download Invoice",
  packagingStatus: "Being Packaged",
  orderCancelled: "Cancelled",
  defaultProductName: "Delicious Treat",
  defaultCustomerName: "Dear Customer",
  orderFetchError: "An error occurred while retrieving your order information.",
  awaitingDate: "Pending",
  fetchingOrder: "Fetching Your Order...",
  deliveryJourney: "Delivery Journey",
  packageTrackingTitle: "Is Your Package {highlight}",
  packageTrackingTitleHighlight: "Safe?",
  trackOrderInstructions: "Enter your order number in the field above to see your package's status in real time.",
  getSupport: "Get Support",
  backToStore: "Back to Store",
  orderHistoryLabel: "Order History",
  deliveryInfoTitle: "Delivery Information",
  needHelpTitle: "Need Help?",
  whatsappHelpText: "You can always reach us about your order via WhatsApp.",
  customerService: "Customer Service",
  notSatisfiedTitle: "Not happy with your product?",
  returnExchangeText: "You can request a return or exchange.",
  createReturnRequest: "Create Return Request",

  // Cash on Delivery Options
  deliveryOptionsLoadError: "An error occurred while loading delivery options.",
  loadingDeliveryOptions: "Loading delivery options...",
  codTitle: "Cash on Delivery & Delivery Options",
  noDeliveryScheduleForCity: "There is currently no delivery schedule for this city.",
  tryDifferentMethodOrLater: "Please choose a different delivery method or try again later.",
  currentMonthLabel: "Current Month",
  codAvailable: "Available",
  moreDatesAvailable: "+{count} more dates available",
  nextMonthLabel: "Next Month",
  codScheduled: "Scheduled",
  currentMonthScheduleCompleted: "This month's delivery schedule is complete",
  currentMonthPassedNextAvailable: "The delivery dates planned for this month have passed. Delivery is available next month.",
  selectedDeliveryDateLabel: "Selected Delivery Date",
  activeDeliverySchedules: "Active Delivery Schedules",

  // Payment Methods
  payWithCard: "Pay with Card",
  cashOnDeliveryLabel: "Cash on Delivery",
  selectPaymentMethod: "Select Payment Method",
  noActivePaymentMethod: "No active payment method is available right now. Please contact the administrator.",
  paymentProcessingError: "An error occurred while processing your payment.",
  pay: "Pay",
  redirecting: "Redirecting...",
  payWithMethod: "Pay with {method}",
  paymentAmountLabel: "Payment amount",
  redirectingToPaymentPage: "You will be redirected to the payment page.",
  mollieStartFailed: "The Mollie payment could not be started.",
  cashOnDeliveryDesc: "You can pay in cash or by card upon delivery.",
  confirmOrder: "Confirm Order",
  orderWithPaymentObligation: "Order with obligation to pay",
  cardNotStoredDesc: "For your security, your card details are never stored on our systems. Every order is processed securely through Stripe or Mollie.",
  calculatingDeliveryDates: "Calculating delivery dates...",
  noDeliveryScheduleContact: "No delivery schedule has been set up yet for \"{city}\". Please get in touch with us.",
  deliveryInfoLabel: "Delivery Information",
  deliveryDaysLabel: "Delivery days:",
  upcomingDeliveryDates: "Upcoming Delivery Dates",
  freeShippingOverAmount: "Free over {amount}",
  selectCityLabel: "Select City",
  cityListLoadFailed: "The city list could not be loaded",
  paymentVerifying: "Verifying Payment",
  paymentVerifyingDesc: "Your payment is being verified, please wait...",
  paymentSuccessful: "Payment Successful!",
  orderReceivedRedirecting: "Your order has been received, redirecting you...",

  // Reviews
  customerReviews: "Customer Reviews",
  writeReview: "Write Review",
  reviewTitle: "Review Title",
  yourReview: "Your Review",
  yourName: "Your Name",
  yourFullName: "Your Full Name",
  submitReview: "Submit Review",
  verified: "Verified",
  wasHelpful: "Was this review helpful?",
  yes: "Yes",
  no: "No",
  noReviewsYet: "No reviews yet",
  beFirstToReview: "Be the first to review this product!",
  writeFirstReview: "Write First Review",

  // Profile
  personalInfo: "Personal Information",
  profileUpdated: "Profile updated successfully!",

  // Email Notifications
  emailNotifications: "Email Notifications",
  language: "Language",
  orderConfirmations: "Order Confirmations",
  orderConfirmationsDesc: "Receive confirmation emails when you place an order",
  shippingUpdates: "Shipping Updates",
  shippingUpdatesDesc: "Get notified when your order ships",
  deliveryNotifications: "Delivery Notifications",
  deliveryNotificationsDesc: "Receive notifications when your order is delivered",
  marketingEmails: "Marketing Emails",
  marketingEmailsDesc: "Receive promotional emails and special offers",
  newsletter: "Newsletter",
  newsletterDesc: "Stay updated with our latest news and products",
  productRecommendations: "Product Recommendations",
  productRecommendationsDesc: "Get personalized product recommendations",
  reviewReminders: "Review Reminders",
  reviewRemindersDesc: "Reminders to review products you've purchased",
  specialOffers: "Special Offers",
  specialOffersDesc: "Exclusive offers and discounts",
  birthdayOffers: "Birthday Offers",
  birthdayOffersDesc: "Special offers on your birthday",
  emailFrequency: "Email Frequency",
  emailFrequencyDesc: "We respect your inbox and will only send relevant emails. You can change these settings anytime.",

  // Wishlist
  wishlist: "Wishlist",
  myWishlist: "My Wishlist",
  wishlistEmpty: "Your Wishlist is Empty",
  wishlistEmptyDesc: "You haven't added any products to your wishlist yet. Click the heart icon on products you like to add them to your wishlist.",
  removeFromWishlist: "Remove from Wishlist",
  wishlistItemsCount: "You have {count} items in your wishlist",
  addAllToCart: "Add All to Cart",
  clearWishlist: "Clear Wishlist",
  clearWishlistConfirm: "Are you sure you want to clear your wishlist?",
  totalValue: "Total Value",
  addedToCart: "added to cart!",
  allItemsAddedToCart: "All items added to cart!",
  startShopping: "Start Shopping",
  lastUpdatedLabel: "Last Updated",

  // Coupons
  haveCoupon: "Have a Coupon Code?",
  enterCouponCode: "Enter coupon code",
  apply: "Apply",
  couponApplied: "Coupon Applied",
  invalidCoupon: "Invalid coupon code",
  couponExpired: "Coupon has expired",
  minPurchaseNotMet: "Minimum purchase amount not met",
  couponError: "Coupon error",
  availableCoupons: "Available Coupons",
  couponCopied: "Coupon copied",
  validUntil: "Valid Until",
  minPurchase: "Min. Purchase",
  copy: "Copy",
  freeShipping: "Free Shipping",

  // FAQ
  frequentlyAskedQuestions: "Frequently Asked Questions",
  faqQuestion1: "How can I track my order?",
  faqAnswer1: "You can track your order by entering your order number on the 'Order Tracking' page or using the tracking link sent by email.",
  faqQuestion2: "What is the shipping time?",
  faqAnswer2: "Our shipping time to Belgium and Netherlands is 3-5 business days. For special cases, you can contact our customer service.",
  faqQuestion3: "What payment methods do you accept?",
  faqAnswer3: "You can pay with credit card, bank transfer and PayPal. All payments are processed securely.",
  faqQuestion4: "What is the return policy?",
  faqAnswer4: "You can contact our support team within 2 days from the delivery date of your products.",
  faqQuestion5: "Are your products natural?",
  faqAnswer5: "Yes, all our products are prepared with natural ingredients. They contain no preservatives or artificial additives.",
  faqQuestion6: "How can I become a member?",
  faqAnswer6: "You can create a free account by clicking the 'Register' button in the top right corner. You can easily register with your email address and password.",
  faqQuestion7: "Are your products halal certified?",
  faqAnswer7: "Yes, all our products are halal certified. We ensure compliance with halal standards in our production processes and are regularly audited. We are happy to share our certificates with our customers.",
  faqQuestion8: "Is the nutritional value of frozen products preserved?",
  faqAnswer8: "Yes, we use rapid freezing technology to preserve the nutritional value and taste of our products. This way you get the taste as if freshly prepared.",
  faqQuestion9: "Do your products contain additives?",
  faqAnswer9: "No, we do not use artificial additives in our products. Our products, prepared with traditional methods and natural ingredients, are both healthy and delicious.",

  // About Page
  aboutUs: "About Us",
  ourStory: "Our Story",
  ourStoryText: "Eticaret was born with the vision of bringing the deep-rooted Turkish culinary tradition to the modern world. By combining our grandmothers' recipes passed down through generations with today's hygiene standards and technological possibilities, we enable everyone to experience traditional flavors at home.",
  ourMissionText: "Our goal is not only to offer delicious products, but also to introduce the richness of Turkish culture to the world. Each of our products is prepared using traditional methods, hygienically packaged and delivered to everyone as frozen products.",
  halalCertified: "Halal Certified",
  ourValues: "Our Values",
  traditionalCraftsmanship: "Traditional Craftsmanship",
  traditionalCraftsmanshipText: "Each of our products is prepared with years of experience and love. We present our traditional recipes by blending them with modern techniques.",
  qualityAssurance: "Quality Assurance",
  qualityAssuranceText: "We prioritize customer satisfaction with our products that are carefully controlled at every stage using the highest quality materials.",
  halalCertifiedValue: "Halal Certified",
  halalCertifiedValueText: "All our products are halal certified and we gain the trust of our customers who have religious sensitivities.",
  followUsText: "You can follow our latest news from our social media accounts and stay informed about our new products.",
  ourProductionProcess: "Our Production Process",
  freezingTechnology: "Freezing Technology",
  freezingTechnologyText: "We preserve taste and nutritional value using rapid freezing technology.",
  qualityAndHygiene: "Quality and Hygiene",
  qualityAndHygieneText: "We produce under hygienic conditions according to European standards with the highest quality materials.",
  globalAccess: "Global Access",
  globalAccessText: "We deliver Turkish flavors to every corner of the world with frozen product technology.",
  followUsOnSocialMedia: "Follow Us on Social Media",
  followUsOnSocialMediaText: "Follow the stories of our traditional flavors, our production processes and our special campaigns on social media!",
  aboutHeroTagline: "From Tradition to the Future",
  aboutHeroTitlePrefix: "Anatolia's",
  aboutHeroTitleHighlight: "Ancient Story",
  aboutHeroQuote: "A thousand-year-old legacy of flavor, kneaded by the richness of the soil, matured by fire, and turned into art by the hands of masters.",
  aboutHeritageTitlePrefix: "A Thousand Years of",
  aboutHeritageTitleHighlight: "the Rhythm of Fire",
  aboutNaturalContentLabel: "Natural Content",
  aboutTraditionalRecipeLabel: "Traditional Recipes",
  aboutCraftsmanshipTitle: "Artisan Precision, Anatolian Patience",
  aboutValuesTitlePrefix: "What's",
  aboutValuesTitleHighlight: "Sacred to Us",
  categoryGeneral: "General",
  categoryOrder: "Order",
  categoryProduct: "Product",
  categoryPayment: "Payment",
  categoryShipping: "Shipping",
  categoryTechnical: "Technical",
  categoryComplaint: "Complaint",
  categorySuggestion: "Suggestion",
  priorityLabel: "Priority",
  priorityLow: "Low",
  priorityMedium: "Medium",
  priorityHigh: "High",
  priorityUrgent: "Urgent",
  selectSubject: "Select a subject",
  subjectInfo: "Information",
  subjectOther: "Other",
  namePlaceholder: "Your full name",
  emailPlaceholder: "example@email.com",
  phonePlaceholder: "+32 555 123 456",
  messagePlaceholder: "Write your message here...",
  createSupportTicket: "Create Support Ticket",
  ticketCreatedSuccess: "Your support ticket has been created successfully! Ticket number: {ticketNumber}",
  ticketCreationError: "An error occurred while creating your support ticket. Please try again.",
  socialMedia: "Social Media",

  // Contact Page
  contactUs: "Contact",
  contactDescription: "Get in touch with us. We are happy to answer your questions and help you.",
  contactForm: "Contact Form",
  contactFormDescription: "You can contact us by filling out the form below. We will get back to you as soon as possible.",
  subject: "Subject",
  yourMessage: "Your Message",
  country: "Country",
  address: "Address",
  phone: "Phone",
  email: "Email",

  // Support Page
  customerSupport: "Customer Support",
  supportDescription: "How can we help you? We are here to answer your questions and solve your problems.",
  needMoreHelp: "Need More Help?",
  contactUsDirectly: "Contact us directly",

  // Footer
  quickLinks: "Quick Links",
  categories: "Categories",
  desserts: "Desserts",
  contactInfo: "Contact Information",
  allRightsReserved: "All rights reserved.",
  privacyPolicy: "Privacy Policy",
  paymentMethods: "Payment Methods",
  workingHours: "Working Hours",

  // Footer Newsletter & Trust
  worldOfPrivileges: "World of Privileges",
  newsletterTitleLine1: "Be the First to Know",
  newsletterTitleHighlight: "About Palace Flavors",
  newsletterDescriptionFooter: "Be the first to hear about our new products, limited-edition flavors and offers exclusive to our subscribers.",
  subscribe: "Subscribe",
  unsubscribeNote: "* You can unsubscribe at any time.",
  footerBrandDescription: "We blend Anatolia's thousand-year-old traditions with the freshest ingredients and bring them to your table with a modern presentation. We serve you with a boutique production approach that never compromises on quality.",
  footerFavoriteFlavors: "Favorite Flavors",
  footerCategoryDesserts: "Desserts & Cakes",
  footerCategoryPastries: "Pastries & Börek",
  footerCategoryMains: "Traditional Dishes",
  footerCategoryIceCream: "Ice Cream & Cold Desserts",
  footerCategoryGrocery: "Grocery & Grains",
  headOffice: "Head Office",
  customerLine: "Customer Line",
  naturalContentTrustDesc: "No preservatives, artificial colorants or corn syrup are used in our products.",
  coldChainDelivery: "Cold Chain Delivery",
  coldChainDeliveryDesc: "With our special packaging system, we deliver fresh products anywhere in Belgium within 48 hours.",
  securePaymentInfrastructure: "Secure Payment Infrastructure",
  securePaymentInfrastructureDesc: "All your payments are protected with 256-bit SSL, backed by Stripe and Bancontact.",
  distanceSalesAgreement: "Distance Sales Agreement",

  // Hero Banner
  heroDefaultTitle: "Turkish Cuisine",
  heroDefaultSubtitle: "Traditional Turkish Flavors",
  heroDefaultDescription: "Palace flavors crafted by master hands with 100% natural ingredients, now at your door.",
  heroDefaultButtonText: "Discover Now",
  heroDefaultBadge: "Special Selection",
  heroLoadingText: "Preparing the Palace Kitchen...",

  // Home Page (main hero & sections)
  homeSeoTitle: "Eticaret — Traditional Turkish Flavors",
  homeSeoDescription: "Delivered to Belgium: baklava, börek, manti, ice cream and more. Fresh, frozen, at your door.",
  homeHeroFreeShippingBadge: "Free Delivery to Belgium — Over €50",
  homeHeroTitleLine1: "Anatolia's",
  homeHeroTitleHighlight: "Freshest",
  homeHeroTitleSuffix: "Flavors",
  homeHeroDescription: "Baklava, börek, manti, ice cream — frozen and fresh. Right to your home.",
  promoFreeShippingOver50: "Free Shipping Over €50",
  promoFrozenFreshDelivery: "Frozen — Delivered Fresh",
  promoNaturalIngredient: "Natural Ingredients",
  promoSecurePayment: "Secure Payment",
  featuredProductsTitle: "Featured Products",
  viewAll: "View All",
  campaignsTitle: "Campaigns",
  campaignsBadge: "Limited Time",
  campaignsSubtitle: "Discounted deals on selected products",
  viewAllCampaigns: "View All Campaigns",
  campaignsSaving: "savings",
  campaignsEmpty: "There are no active deal campaigns right now.",
  collectionLabel: "Collection",
  whyEticaret: "Why Eticaret?",
  whyEticaretSubtitle: "We Offer You the Best",
  whyFrozenFreshTitle: "Frozen Fresh",
  whyFrozenFreshDesc: "Our products are prepared with the freshest recipes and immediately frozen, preserving both flavor and nutritional value. The freezing process stops microbial growth, ensuring your products stay fresh for longer.",
  whyBelgiumWideTitle: "All Over Belgium",
  whyBelgiumWideDesc: "Free delivery across Belgium for orders over €50. Our fast and secure logistics network ensures your order arrives quickly and safely. Every shipment includes tracking and monitoring.",
  whyAllNaturalTitle: "100% Natural",
  whyAllNaturalDesc: "All our products are made with natural ingredients, without any additives, colorings, or artificial sweeteners. Following traditional recipes, we bring you pure, authentic flavors - just like home-cooked meals.",
  whySecurePaymentTitle: "Secure Payment",
  whySecurePaymentDesc: "Choose from cash on delivery, card payment, or secure online payment via Stripe/Mollie. All transactions are protected with SSL encryption.",
  ctaDiscoverAllProducts: "Discover All Products",
  ctaProductCountDesc: "31 traditional products, delivered to your door",

  // Common
  loading: "Loading...",
  connectionRestored: "Connection restored!",
  noInternetConnection: "No internet connection",
  cartTooltip: "My Cart ({count} items)",
  skipToMainContent: "Skip to main content",
  error: "Error",
  success: "Success",
  save: "Save",
  edit: "Edit",
  add: "Add",
  view: "View",
  submit: "Submit",
  total: "Total",
  subtotal: "Subtotal",
  tax: "Tax",
  shipping: "Shipping",
  discountAmount: "Discount",
  free: "Free",

  // Social Media
  share: "Share",
  linkCopied: "Link copied!",
  followUs: "Follow Us",
  followUsOn: "Follow us on",

  // Live Support
  online: "Online",
  offline: "Offline",

  // Support Page
  emailSupportDesc: "Response within 24 hours",
  sendEmail: "Send Email",
  whatsappSupport: "WhatsApp Support",
  whatsappSupportDesc: "Quick messaging",
  whatsappGreetingMessage: "Hello! I'd like some support.",
  messageWhatsApp: "Message on WhatsApp",

  cancel: "Cancel",

  // Search & Filters
  searchPlaceholder: "Search products...",
  suggestions: "Suggestions",
  recentSearches: "Recent Searches",
  filters: "Filters",
  category: "Category",
  subcategory: "Subcategory",
  allSubcategories: "All Subcategories",
  priceRange: "Price Range",
  newProducts: "New Products",
  recommendedForYou: "Recommended For You",
  popular: "Popular",
  onSale: "On Sale",
  brand: "Brand",
  origin: "Origin",
  sortBy: "Sort By",
  relevance: "Relevance",
  priceLow: "Price (Low-High)",
  priceHigh: "Price (High-Low)",
  newest: "Newest",
  name: "Name",
  searching: "Searching",
  showAllProducts: "Show All Products",
  unknown: "Unknown",

  // Inventory Management
  overview: "Overview",
  alerts: "Alerts",
  outOfStock: "Out of Stock",
  inStock: "In Stock",
  product: "Product",
  minStock: "Min. Stock",

  // Admin Dashboard
  orders: "Orders",
  customers: "Customers",
  reviews: "Reviews",
  reports: "Reports",
  settings: "Settings",
  totalOrders: "Total Orders",
  totalRevenue: "Total Revenue",
  totalCustomers: "Total Customers",

  // Analytics & Reporting
  analyticsDashboard: "Analytics Dashboard",
  businessOverview: "Business Overview",
  salesAnalytics: "Sales Analytics",
  customerAnalytics: "Customer Analytics",
  inventoryAnalytics: "Inventory Analytics",
  marketingAnalytics: "Marketing Analytics",
  reportsAndExports: "Reports and Exports",
  last7Days: "Last 7 Days",
  last30Days: "Last 30 Days",
  last90Days: "Last 90 Days",
  lastYear: "Last Year",
  dateRange: "Date Range",
  vsLastMonth: "vs Last Month",
  averageOrderValue: "Average Order Value",
  conversionRate: "Conversion Rate",
  newCustomers: "New Customers",
  averageCustomerValue: "Average Customer Value",
  turnoverRate: "Turnover Rate",
  averageStockDays: "Average Stock Days",
  totalVisitors: "Total Visitors",
  uniqueVisitors: "Unique Visitors",
  bounceRate: "Bounce Rate",
  avgSessionDuration: "Avg. Session Duration",
  revenueTrend: "Revenue Trend",
  revenueByCategory: "Revenue by Category",
  customerSegments: "Customer Segments",
  trafficSources: "Traffic Sources",
  conversionFunnel: "Conversion Funnel",
  topMovingProducts: "Top Moving Products",
  unitsSold: "Units Sold",
  generateReport: "Generate Report",
  exportData: "Export Data",
  reportType: "Report Type",
  salesReport: "Sales Report",
  customerReport: "Customer Report",
  inventoryReport: "Inventory Report",
  marketingReport: "Marketing Report",
  comprehensiveReport: "Comprehensive Report",
  generatePDF: "Generate PDF",
  generateExcel: "Generate Excel",
  exportSalesData: "Export Sales Data",
  exportCustomerData: "Export Customer Data",
  exportInventoryData: "Export Inventory Data",
  exportMarketingData: "Export Marketing Data",

  // Navigation
  confirmLogout: "Are you sure you want to logout?",
  collections: "Collections",
  collectionsMenuTitleLine1: "Special Discoveries",
  collectionsMenuTitleHighlight: "From Anatolia",
  collectionsMenuSubtitle: "Traditional Recipes, Modern Presentation",
  viewAllCollections: "View All Collections",
  discover: "Discover",
  sustainableShipping: "Sustainable Shipping",
  allNaturalContent: "100% Natural Content",
  allCategoryProducts: "All {category} Products",
  logoAlt: "Logo",
  cookiePolicy: "Cookie Policy",
  termsOfUse: "Terms of Use",
  cookieUsageTitle: "Cookie Usage",
  cookieUsageDescPrefix: "By using our site, we use cookies to improve our website's performance and provide you with better service. For more details, please read our",
  cookieUsageDescSuffix: ".",
  onlyNecessary: "Only Necessary",
  acceptAll: "Accept All",
  cookiePreferencesTitle: "Cookie Preferences",
  cookiePreferencesDesc: "You can choose which cookies you'd like to accept",
  necessaryCookiesTitle: "Necessary Cookies",
  alwaysActive: "Always active",
  necessaryCookiesDesc: "Required for the website's basic functions to work. These cannot be disabled.",
  performanceCookiesTitle: "Performance Cookies",
  performanceCookiesDesc: "Used to analyze website performance and user experience.",
  examplesLabel: "Examples",
  functionalCookiesTitle: "Functional Cookies",
  functionalCookiesDesc: "Used to remember your preferences and provide a personalized experience.",
  functionalCookiesExamples: "Language preferences, regional settings",
  marketingCookiesTitle: "Marketing Cookies",
  marketingCookiesDesc: "Used to show you more relevant ads and for marketing analysis.",
  saveMyPreferences: "Save My Preferences",
  
  // Email Verification
  emailVerification: "Email Verification",
  emailVerificationRequired: "Email Verification Required",
  emailVerificationMessage: "Please click the verification link sent to {email} to verify your email address.",
  emailVerifiedSuccessfully: "Email Successfully Verified",
  emailVerifiedMessage: "Your email address has been successfully verified. You can now enjoy all features.",
  emailVerificationFailed: "Email Verification Failed",
  emailVerificationFailedMessage: "Email verification failed. Please try again.",
  checkYourEmail: "Check Your Email",
  emailVerificationInstructions: "Click the verification link sent to your email address to verify your account.",
  resendVerificationEmail: "Resend Verification Email",
  resendVerificationDescription: "Fill out the form below to send a verification email to your email address.",
  sendVerificationEmail: "Send Verification Email",
  verifyingEmail: "Verifying email...",
  verificationStatusCheckFailed: "Could not check email verification status",
  verificationEmailSent: "Verification email sent",
  verificationEmailSendFailed: "The email could not be sent",
  pleaseWaitSeconds: "Please wait {seconds} seconds",
  continueToProfile: "Continue to Profile",
  backToProfile: "Back to Profile",
  backToHome: "Back to Home",
  resendIn: "Resend in",
  sending: "Sending...",
  dismiss: "Dismiss",
  needHelp: "Need Help?",
  didntReceiveEmail: "Didn't receive the email?",
  checkSpamFolder: "Check your spam folder and make sure the email wasn't marked as spam.",
  wrongEmailAddress: "Wrong email address?",
  contactSupportMessage: "Contact our support team.",
  verificationLinkExpired: "Verification link expired?",
  requestNewVerification: "Request a new verification email.",
  pleaseEnterEmail: "Please enter your email address.",
  emailAddress: "Email Address",
  enterEmailAddress: "Enter your email address",

  // Products Page
  anatolianCollectionLabel: "Anatolian Collection",
  listedProducts: "Listed",
  noResultsTitle: "Nothing Matches Just Yet",
  noResultsDescription: "We couldn't find products matching your criteria. Please clear the filters and try again.",

  // Product Card
  newLabel: "New",
  addingToCart: "Adding...",
  quickAdd: "QUICK ADD",

  // Product Detail
  productNotFound: "Product Not Found",
  productNotFoundDesc: "The product you're looking for doesn't exist or has been removed.",
  backToProducts: "Back to Products",
  selectionRequired: "* Please select",
  lastUnitsLeft: "(Only {count} left)",
  selectVariant: "Select a Variant",
  readReturnPolicy: "You can read our return policy here",
  codPaymentNote: "Cash on delivery may be available; final confirmation depends on your address at checkout.",
  selectCityForDelivery: "Select your city above to see delivery days and cash-on-delivery availability.",
  productCode: "Product Code",
  nutritionalValues: "Nutritional Values",

  // Product Filters
  filterOptionsHeading: "Options",
  reset: "Reset",
  allPrefix: "ALL",
  preferences: "Preferences",
  doesNotContainSuffix: "FREE",
  traditionalMethodsLine1: "Prepared with traditional methods,",
  traditionalMethodsLine2: "made with care.",

  // Product Gallery
  clickToCloseZoom: "Click to close zoom",
  zoomOut: "Zoom Out",
  zoomIn: "Zoom In",

  // Product Reviews
  fillRequiredFields: "Please fill in all required fields.",
  reviewSubmittedPendingApproval: "Your review has been submitted for moderation and will be published once approved.",
  reviewSubmitFailed: "Couldn't submit your review. Please try again.",
  outOf5: "out of 5",
  basedOnReviews: "Based on {count} reviews",
  summarizeExperience: "Summarize your experience",
  tellUsExperience: "Tell us about your experience with this product",

  // Login Page
  welcomeBack: "Welcome Back",
  loginSubtitle: "Sign in to your account",
  exampleEmailPlaceholder: "example@email.com",
  password: "Password",
  enterPasswordPlaceholder: "Enter your password",
  rememberMe: "Remember me",
  forgotPasswordLink: "Forgot your password?",
  loggingIn: "Signing In...",
  or: "or",
  continueWithGoogle: "Sign in with Google",
  dontHaveAccount: "Don't have an account?",
  signUpNow: "Sign up",
  loginErrorGeneric: "An error occurred while signing in!",

  // Register Page
  registerSubtitle: "Join the Turkish Cuisine family",
  firstNameRequired: "First name is required",
  lastNameRequired: "Last name is required",
  emailRequired: "Email is required",
  invalidEmail: "Enter a valid email address",
  passwordRequired: "Password is required",
  passwordMinLength: "Password must be at least 6 characters",
  passwordsDoNotMatch: "Passwords do not match",
  cityRequired: "City selection is required",
  agreeTermsRequired: "You must accept the terms and conditions",
  registerErrorGeneric: "An error occurred while registering!",
  firstNamePlaceholder: "Your first name",
  lastNamePlaceholder: "Your last name",
  phonePlaceholderExample: "0555 123 45 67",
  cityDeliveryHelperText: "Needed so we can show cash-on-delivery availability and delivery days.",
  passwordMinCharsPlaceholder: "At least 6 characters",
  confirmPassword: "Confirm Password",
  confirmPasswordPlaceholder: "Re-enter your password",
  wantMarketingEmails: "I'd like to receive emails about promotions and new arrivals.",
  registering: "Signing Up...",
  registerWithGoogle: "Sign up with Google",
  alreadyHaveAccount: "Already have an account?",
  loginNow: "Sign in",

  // Forgot / Reset Password
  forgotPasswordTitle: "Forgot Password",
  forgotPasswordDescription: "Enter your email address and we'll send you a reset link.",
  resetLinkSentDefault: "Reset link sent.",
  genericErrorRetry: "An error occurred. Please try again.",
  checkSpamReminder: "Don't forget to check your spam folder too.",
  sendResetLink: "Send Reset Link",
  backToLoginLink: "Back to Login",
  invalidLinkTitle: "Invalid Link",
  invalidLinkDesc: "The password reset link is missing or invalid.",
  requestNewLink: "Request a new link",
  setNewPasswordTitle: "Set a New Password",
  minCharsHint: "Use at least 6 characters.",
  passwordResetSuccessDefault: "Your password has been reset successfully.",
  invalidOrExpiredLink: "Invalid or expired link.",
  redirectingToLogin: "Redirecting you to the login page...",
  newPassword: "New Password",
  saving: "Saving...",
  resetPasswordButton: "Reset My Password",

  // OAuth Callback
  invalidLoginLink: "The login link is invalid.",
  loginFailedGeneric: "Login failed.",
  loggingInEllipsis: "Signing in…",

  // Profile Page
  myProfile: "My Profile",
  manageAccountInfo: "Manage your account information",
  myOrders: "My Orders",
  security: "Security",
  memberSince: "Member since",
  favoriteProducts: "Favorite Products",
  averageRating: "Average Rating",
  itemsCountSuffix: "items",
  details: "Details",
  noOrdersYet: "You haven't placed any orders yet",
  discoverProductsForFirstOrder: "Explore our products to place your first order",
  myFavoriteProducts: "My Favorite Products",
  noFavoritesYet: "You don't have any favorite products yet",
  addFavoritesHint: "Add products you like to your favorites",
  exploreProducts: "Explore Products",
  securitySettings: "Security Settings",
  changePassword: "Change Password",
  lastPasswordChange: "Last changed: 3 months ago",
  changeAction: "Change",
  twoFactorAuth: "Two-Factor Authentication",
  twoFactorAuthDesc: "Make your account more secure",
  enableAction: "Enable",
  sessionHistory: "Session History",
  sessionHistoryDesc: "View your active sessions",
  profileUpdateError: "An error occurred while updating your profile. Please try again.",
  orderStatusPending: "pending",
  orderStatusConfirmed: "confirmed",
  orderStatusProcessing: "being prepared",
  orderStatusShipped: "shipped",
  orderStatusDelivered: "delivered",
  orderStatusCancelled: "cancelled",
  orderStatusRefunded: "refunded",
  orderStatusNotification: "Your order {orderNumber}: {status}",

  // Email Notification Settings
  loadPreferencesError: "An error occurred while loading notification preferences",
  userNotFound: "User information not found",
  saveSettingsError: "An error occurred while updating settings",
  emailSettingsUpdated: "Email settings updated successfully!",
  selectEmailsToReceive: "Choose which emails you'd like to receive",
  currentFrequencyLabel: "Current frequency:",
  weeklyEmailLimitText: "Maximum 2-3 emails per week",

  // Natural Ingredients Page
  naturalIngredientsTitle: "🌿 Natural Ingredients",
  naturalIngredientsIntro: "We prepare our products using only the finest, natural and fresh ingredients. No preservatives, artificial sweeteners or additives whatsoever.",
  naturalIngredients100Title: "100% Natural Ingredients",
  naturalIngredientsDesc1: "As Turkish Cuisine, we use only natural and organic ingredients in our products. While preserving our traditional recipes, we also apply modern hygiene standards.",
  naturalIngredientsListIntro: "The ingredients we use in every product:",
  ingredientHoney: "Natural honey varieties",
  ingredientWalnut: "Organic walnuts and pistachios",
  ingredientFlour: "Traditional flour varieties",
  ingredientAroma: "Natural aromas and spices",
  ingredientSugar: "Organic sugar and sweeteners",
  naturalHoneyTitle: "Natural Honey",
  naturalHoneyDesc: "Our natural honey varieties selected from Anatolia's finest honeys",
  organicWalnutTitle: "Organic Walnuts",
  organicWalnutDesc: "Traditional flavors with our fresh walnut and pistachio varieties",
  traditionalFlourTitle: "Traditional Flour",
  traditionalFlourDesc: "Our flour varieties produced using traditional methods",
  qualityCertificatesTitle: "Our Quality Certificates",
  halalCertTitle: "Halal Certificate",
  halalCertDesc: "All our products are halal certified",
  organicCertTitle: "Organic Certificate",
  organicCertDesc: "Our ingredients are organic certified",
  discoverNaturalIngredientsTitle: "Discover Our Natural Ingredients",
  discoverNaturalIngredientsDesc: "Browse our products made with natural ingredients and place your order",
  reviewOurProducts: "Review Our Products",

  // Master Hands Page
  masterHandsTitle: "👩‍🍳 Master Hands",
  masterHandsIntro: "Every one of our products is prepared with years of experience and love. We blend our traditional recipes with modern techniques.",
  traditionalRecipesTitle: "Traditional Recipes",
  masterHandsDesc1: "We present our traditional recipes, passed down from our grandfathers and grandmothers, blended with modern hygiene standards.",
  masterHandsListIntro: "The qualities of our master hands:",
  masterHandsFeature1: "Experience spanning 3 generations",
  masterHandsFeature2: "Preservation of traditional recipes",
  masterHandsFeature3: "Modern hygiene standards",
  masterHandsFeature4: "Family warmth in every product",
  masterHandsFeature5: "Meticulous quality control",
  masterMehmetName: "Master Mehmet",
  masterMehmetDesc: "30 years of experience, traditional baklava master",
  masterFatmaName: "Mrs. Fatma",
  masterFatmaDesc: "Helva and sucuk expert, 25 years of experience",
  masterAliName: "Master Ali",
  masterAliDesc: "Honey expert, 20 years of beekeeping experience",
  productionProcessTitle: "Our Production Process",
  processStep1Title: "Ingredient Selection",
  processStep1Desc: "We select the finest ingredients",
  processStep2Title: "Traditional Recipe",
  processStep2Desc: "We apply our grandfathers' recipes",
  processStep3Title: "Master Hands",
  processStep3Desc: "Our experienced masters prepare it",
  processStep4Title: "Quality Control",
  processStep4Desc: "We put every product through quality control",
  discoverMasterHandsTitle: "Discover the Work of Our Master Hands",
  discoverMasterHandsDesc: "Browse our products made with traditional recipes and place your order",

  // Fast Delivery Page
  fastDeliveryTitle: "🚚 Fast Delivery",
  fastDeliveryIntro: "We bring your fresh products to your door in the shortest time possible. We offer special packaging and a secure delivery guarantee.",
  fastSecureDeliveryTitle: "Fast and Secure Delivery",
  fastDeliveryDesc1: "We deliver your orders to your door in the shortest time possible. We safely transport our fresh products in special packaging.",
  fastDeliveryListIntro: "Our delivery features:",
  deliveryFeature1: "Delivery within 24 hours",
  deliveryFeature2: "Special cold-chain packaging",
  deliveryFeature3: "Secure packaging",
  deliveryFeature4: "Cash on delivery option",
  deliveryFeature5: "Free shipping (over 150 TL)",
  fastDeliveryCardTitle: "Fast Delivery",
  fastDeliveryCardDesc: "Delivery guarantee within 24 hours",
  specialPackagingTitle: "Special Packaging",
  specialPackagingDesc: "Secure packaging with cold chain",
  secureDeliveryTitle: "Secure Delivery",
  secureDeliveryDesc: "Cash on delivery and secure delivery",
  deliveryProcessTitle: "Our Delivery Process",
  deliveryStep1Title: "Order Received",
  deliveryStep1Desc: "We receive your order",
  deliveryStep2Title: "Preparation",
  deliveryStep2Desc: "We prepare the fresh products",
  deliveryStep3Title: "Packaging",
  deliveryStep3Desc: "We pack them in special packaging",
  deliveryStep4Title: "Delivery",
  deliveryStep4Desc: "We deliver to your door",
  deliveryAreasTitle: "Our Delivery Areas",
  deliveryFeesTitle: "Delivery Fees",
  deliveryFeeOver50: "Orders over €50:",
  deliveryFeeFree: "FREE",
  deliveryFeeUnder50: "Orders under €50:",
  deliveryFeeFast: "Fast delivery (12 hours):",
  orderNowWithFastDelivery: "Order Now with Fast Delivery",
  orderNowWithFastDeliveryDesc: "We bring your fresh products to your door with fast delivery",
  orderNowButton: "Order Now",

  // Return Request Page
  reasonDamaged: "Damaged / Defective Product",
  reasonWrongItem: "Wrong Item Sent",
  reasonNotAsDescribed: "Not as Described",
  reasonChangedMind: "Changed My Mind",
  orderNotFoundPeriod: "Order not found.",
  orderNotFoundForNumber: "No order was found with this order number.",
  returnRequestSubmitError: "The request could not be sent. Please try again.",
  returnRequestReceivedTitle: "Your Return Request Has Been Received",
  returnRequestReceivedDesc: "Your request is under review. You will be notified by email as soon as possible.",
  trackTheOrder: "Track Order",
  returnRequestPageDesc: "You can submit a return request for your delivered orders.",
  orderInfoTitle: "Order Information",
  orderNumberLabel: "Order Number",
  orderNumberPlaceholder: "e.g. 1234567890",
  findOrderButton: "Find Order",
  orderAmountLabel: "Amount",
  returnDeliveredOnlyNotice: "A return request can only be created for delivered orders.",
  returnReasonTitle: "Return Reason",
  returnDescriptionLabel: "Description",
  optionalFieldLabel: "(optional)",
  returnDescriptionPlaceholder: "Share additional details about your return...",
  submitReturnRequest: "Submit Return Request",

  // 3D Flipbook Gourmet Catalog
  flipbookSectionBadge: "INTERACTIVE TASTING BUNDLE",
  flipbookSectionTitle: "Anatolian Tasting Brochure",
  flipbookSectionSubtitle: "Turn the pages to explore weekly artisanal selections and exclusive discount coupons.",
  flipbookTabCover: "📖 Cover",
  flipbookCoverBadge: "2026 SPECIAL SELECTION",
  flipbookCoverTitle: "Anatolian Delicacies",
  flipbookCoverSubtitle: "Traditional Master Catalog & Special Deals",
  flipbookCoverDescription: "Centuries-old recipes, stone mills, and copper cauldrons bringing gourmet heritage to your table.",
  flipbookCoverTagline: "📖 Turn the page to discover authentic flavors of Anatolia",
  flipbookCoverCouponTitle: "Catalog Discount",
  flipbookCoverCouponDiscount: "15% Welcome Discount",
  flipbookOpenCatalog: "Open Catalog",
  flipbookTurnPage: "Turn ❯",
  flipbookPrevPage: "Previous Page",
  flipbookNextPage: "Next Page",
  flipbookPageCount: "Page",
  flipbookAutoPlayActive: "⏱️ Auto Flipping",
  flipbookAutoPlayPaused: "⏸️ Paused (Hovering)",
  flipbookPause: "Pause",
  flipbookPlay: "Play",
  flipbookLimitedOffer: "🔥 This offer is available for a limited time.",
  flipbookInspectAndBuy: "View & Purchase Now",
  flipbookTastingPortion: "Tasting Portion / Special Box",
  flipbookNextPageHint: "Turn to next page ❯",
  flipbookCatalogTitleFooter: "Anatolian Delicacies Catalog",

  // Flipbook Sample Page Contents
  flipbookCatDesserts: "Traditional Desserts",
  flipbookTagStar: "Star of the Day",
  flipbookBaklavaTitle: "Carrot Slice & Antep Pistachio Baklava",
  flipbookBaklavaSubtitle: "Gaziantep Emerald Pistachios & Pure Clarified Butter",
  flipbookBaklavaStory: "40 layers of paper-thin hand-rolled filo pastry baked over oak wood fires. A crisp symphony in every bite.",
  flipbookBaklavaFeat1: "100% Natural Beet Sugar",
  flipbookBaklavaFeat2: "Authentic Urfa Clarified Butter",
  flipbookBaklavaFeat3: "Daily Fresh Crafting",

  flipbookCatDeli: "Breakfast & Delicatessen",
  flipbookTagArtisan: "Artisan Selection",
  flipbookCheeseTitle: "Aged Kars Kashar & Gourmet Cheeses",
  flipbookCheeseSubtitle: "From 2400m Alpine Meadows to Your Table",
  flipbookCheeseStory: "Crafted exclusively from summer milk of free-grazing cows, aged naturally for 12 months in caves.",
  flipbookCheeseFeat1: "12 Months Natural Cave Aging",
  flipbookCheeseFeat2: "Additive & Preservative Free",
  flipbookCheeseFeat3: "Cold Chain Express Delivery",

  flipbookCatNatural: "Natural & Wellness",
  flipbookTagPure: "Pure Heritage",
  flipbookOilHoneyTitle: "Wild Hive Honey & Cold Pressed Olive Oil",
  flipbookOilHoneySubtitle: "Nature's Purest Remedies in One Box",
  flipbookOilHoneyStory: "Early harvest cold-pressed olive oil from Mount Ida slopes paired with raw wild hive honey from high mountain plateaus.",
  flipbookOilHoneyFeat1: "Acidity Level < 0.3%",
  flipbookOilHoneyFeat2: "Lab Tested Raw Honey",
  flipbookOilHoneyFeat3: "Protective Wooden Gift Box",

  flipbookCatTreats: "Special Confections",
  flipbookTagPalace: "Palace Tradition",
  flipbookLokumTitle: "Double Roasted Pistachio Turkish Delight",
  flipbookLokumSubtitle: "Simmered in Copper Cauldrons Over Wood Fire",
  flipbookLokumStory: "Prepared with the Ottoman palace recipe, blending fresh pomegranate extract with double-roasted crunchy Antep pistachios.",
  flipbookLokumFeat1: "Gelatin Free & Gluten Free",
  flipbookLokumFeat2: "Extra Rich Double Pistachios",
  flipbookLokumFeat3: "Signature Gift Box"
};
